module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAGFBMVEUAAADAs7DAsrG/tra/srD39vb////RyMYOXKwlAAAABHRSTlMA6aYc+fzKlQAAAFtJREFUSMdjGAUkAmZFF1QgZICpyNAFHQhjKlLBUOSEqUgEQ5EjpiIXFwyBUUWjikYVjSoaVTSqaNAoQgMUKyoNJ0JRWCoeRSJwRXiqVxUM65yIrvIJNx5GBAAAHydr2cIKHQAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/download_icon_phone_default.png
// module id = FAJB
// module chunks = 10